import apiClient from './client.js';

/**
 * Fetch messages for a lead from DB (source of truth).
 *
 * All Reply.io email events (sent, replied, bounced, etc.) arrive via webhooks
 * and are persisted to DB in real-time — no need to poll the provider API.
 * Real-time updates arrive via SSE → cache invalidation → refetch.
 */
export async function fetchMessages (leadId) {
  const { data } = await apiClient.get(`/leads/${leadId}/messages`)
    .catch(() => ({ data: { items: [] } }));

  return (data?.items || []).sort((a, b) => {
    const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
    const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
    return aTime - bTime;
  });
}
